import React from 'react';
import { animated, useSpring } from 'react-spring';

interface Props {
  children: JSX.Element | JSX.Element[];
  transitionDuration?: number;
}

export default function CollapsibleContainer({
  children,
  transitionDuration = 0.25
}: Props) {
  const duration = useSpring({ config: { duration: transitionDuration } });
  return <animated.div style={duration}>{children}</animated.div>;
}
